// The signed-in person's language (Settings › Language). null = not chosen (AI follows how they write).
import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/src/lib/supabase';

export function useMyLanguage() {
  const [language, setLanguage] = useState<string | null>(null);
  const [ready, setReady] = useState(false);
  const [missing, setMissing] = useState(false); // the database update hasn't been run yet

  const load = useCallback(async () => {
    const { data, error } = await supabase.rpc('get_my_language');
    if (error && /get_my_language|function|schema cache/i.test(error.message)) setMissing(true);
    setLanguage(typeof data === 'string' && data ? data : null);
    setReady(true);
  }, []);

  useEffect(() => {
    void load();
    const on = () => void load();
    window.addEventListener('opsalo:profile-updated', on);
    return () => window.removeEventListener('opsalo:profile-updated', on);
  }, [load]);

  const save = useCallback(async (code: string | null) => {
    const { error } = await supabase.rpc('set_my_language', { p_code: code });
    if (error) return /set_my_language|function|schema cache|language/i.test(error.message) ? 'Languages need the latest database updates (20261023070000_languages.sql, then 20261023071000_language_rpc.sql).' : error.message;
    setLanguage(code);
    window.dispatchEvent(new Event('opsalo:profile-updated'));
    return null;
  }, []);

  return { language, ready, missing, save };
}
